<div class="row">
    <div class="col-md-12">
        <div class="card-box messagecard">
            <div class="mat-elevation-z8">
                <div class="table-responsive justify-content-center">
                    <p-table #dt [lazy]="true" (onLazyLoad)="getMessageList($event)" [columns]="cols" [value]="data"
                        [rows]="5" [globalFilterFields]="['Date','From','Subject']" [rowHover]="true" dataKey="id"
                        [paginator]="true" [loading]="loading" [rowsPerPageOptions]="[5,10,15]"
                        class="table-caption-d-flex" [showCurrentPageReport]="true" [(first)]="first"
                        [totalRecords]="totalRecords"
                        currentPageReportTemplate="Showing {first} to {last} of {totalRecords} entries"
                        [showCurrentPageReport]="true" responsiveLayout="scroll">
                        <ng-template pTemplate="caption">
                            <div>

                                <span class="p-input-icon-left">
                                    <button type="button" pButton label="Sent" class="messagebutton"
                                        (click)="sentMessages()"></button>
                                    <button type="button" pButton label="Received" class="messagebutton"
                                        (click)="receivedMessages()"></button>
                                    <button type="button" pButton label="Compose Email" class="messagebutton"
                                        (click)="composeMessages()"></button>
                                </span>
                            </div>
                        </ng-template>

                        <ng-template pTemplate="header">
                            <tr *ngIf="selectedMode ==1">
                                <th style="font-weight: bold;" class="notranslate">To</th>
                                <th style="font-weight: bold;">Subject</th>
                                <th style="font-weight: bold;">Date</th>
                                <th style="font-weight: bold;">Message</th>
                            </tr>
                            <tr *ngIf="selectedMode==2">
                                <th style="font-weight: bold;" class="notranslate">From</th>
                                <th style="font-weight: bold;">Subject</th>
                                <th style="font-weight: bold;">Date</th>
                                <th style="font-weight: bold;">Message</th>
                            </tr>
                        </ng-template>
                        <ng-template pTemplate="body" let-data>
                            <tr *ngIf="selectedMode==1">
                                <td>{{data.to}}</td>
                                <td>{{data.subject}}</td>
                                <td>{{data.date | date: 'd/M/yyyy, h:mm a' }}</td>
                                <td><button pButton type="button" icon="pi pi-info-circle" label="View"
                                        (click)="showDetailMsg(data)"></button></td>

                            </tr>
                            <tr *ngIf="selectedMode==2">
                                <td>{{data.from}}</td>
                                <td>{{data.subject}}</td>
                                <td>{{data.date | date: 'd/M/yyyy, h:mm a' }}</td>
                                <td><button pButton type="button" icon="pi pi-info-circle" label="View"
                                        (click)="showDetailMsg(data)"></button></td>

                            </tr>
                        </ng-template>
                        <ng-template>

                        </ng-template>
                    </p-table>
                </div>
            </div>

        </div>

    </div>

</div>
<app-error-messages style="text-align: center;" [api_result]="this.api_result"></app-error-messages>
<div class="row" *ngIf="compose.read">
    <div class="col-md-12">
        <div class="card-box composecard">
            <div>
                <label style=" margin-right: 55px; font-weight: bold;">
                    {{selectedMode==1?"To :&nbsp; &nbsp; &nbsp; &nbsp; &nbsp; ":"From : &nbsp;&nbsp;"}}
                </label>
                <p style="margin-left:20px; font-weight: bold; display: inline;">
                    {{selectedMode==1?showMsg.to:showMsg.from}}</p>
            </div>

            <div>
                <label style="margin-right: 55px;font-weight: bold;">Subject :</label>
                <input id="Subject" type="text" pInputText placeholder="Subject"
                    style="width:60%;border-radius:15px;margin: 10px;height: 40px; font-weight: bold; color: black;"
                    name="subjectmodel" [(ngModel)]="showMsg.subject" disabled>
            </div>
            <div>
                <label style="vertical-align:top; margin-right: 50px; font-weight: bold;">Message :</label>
                <textarea [rows]="5" [cols]="65" pInputTextarea class="format-lines"
                    style="border-radius:15px;margin: 10px; font-weight: bold; color: black;" name="messagemodel"
                    placeholder="Enter your message here" [(ngModel)]="showMsg.message" disabled></textarea>

            </div>

            <div class="text-center">
                <button pButton type="submit" style="margin:10px;" class="submitbutton" label="Cancel"
                    icon="fa fa-send m-l-5" (click)="closeShowDetailMsg()"></button>
            </div>
        </div>
    </div>
</div>


<div class="row" *ngIf="compose.write">
    <div class="col-md-12">
        <div class="card-box composecard">

            <form #messageForm="ngForm" (ngSubmit)="createMsg()" accept-charset="UTF-8">

                <div>

                    <div class="p-field-radiobutton">
                        <p-radioButton [style]="{'margin-left':'168px','margin-right':'5px','margin-bottom':'5px'}"
                            (ngModelChange)="restMsg()" name="userType" value="patient_user"
                            [(ngModel)]="selectUserType" inputId="city1"></p-radioButton>
                        <label for="city1">Message to Patient</label>

                        <p-radioButton [style]="{'margin-left':'50px','margin-right':'5px','margin-bottom':'5px'}"
                            (ngModelChange)="restMsg()" name="userType" value="doctor_user" [(ngModel)]="selectUserType"
                            inputId="city2"></p-radioButton>
                        <label for="city2">Message to Doctor</label>

                    </div>
                </div>
                <div *ngIf="!this.form_reset">
                    <div>

                        <label style=" margin-right: 55px; font-weight: bold;">To :</label>
                        <input *ngIf="selectUserType=='patient_user'" type="text" [(ngModel)]="patient_name"
                            name="patient_name" pInputText
                            style="width:60%;border-radius:15px;margin-left: 50px;height: 40px;" disabled>
                        <p-multiSelect class="form-control" id="selecteddoctos" autoWidth="false" required
                            styleClass="input-pill-15px patient-view-message-center-doctor-dropdown"
                            *ngIf="selectUserType=='doctor_user'" [options]="doctor_list" [(ngModel)]="selecteddoctos"
                            name="selecteddoctos" #doctos="ngModel" optionLabel="label" optionValue="value">
                        </p-multiSelect>

                    </div>


                    <div>
                        <label style="margin-right: 55px;font-weight: bold;">Subject :</label>
                        <input id="Subject" type="text" pInputText placeholder="Subject"
                            style="width:60%;border-radius:15px;margin: 10px;height: 40px;" name="subjectmodel"
                            #subjectmodel="ngModel" [(ngModel)]="newMessageToSendSubjet"
                            [maxlength]="max_subject_length" required>
                        <div *ngIf="subjectmodel.invalid && (subjectmodel.dirty || subjectmodel.touched)"
                            class="alert alert-danger">
                            <div style="text-align: center;" *ngIf="subjectmodel.errors.required">
                                Subject is required.
                            </div>

                        </div>
                    </div>
                    <div *ngIf="selectUserType=='doctor_user'">

                        <div class="p-field-checkbox">
                            <label style=" margin-right: 55px; font-weight: bold;">Attach Details :</label>

                            <p-checkbox name="mrn" inputId="mrn" [binary]="true" [(ngModel)]="mrnKey"
                                (ngModelChange)="updateMsg()"></p-checkbox>
                            <label style="margin: 8px;" for="mrn">Medical Record Number</label>
                            <p-checkbox name="crn" inputId="crn" [(ngModel)]="crnKey" [binary]="true"
                                (ngModelChange)="updateMsg()"></p-checkbox>
                            <label style="margin: 8px;" for="crn">Consultation Record Number</label>
                        </div>
                        <!-- <div class="p-field-checkbox">
                            <label style=" margin-right: 168px; font-weight: bold;"></label>
                            <p-checkbox name="pvl" inputId="pvl" [(ngModel)]="pvlKey" [binary]="true"
                                (ngModelChange)="updateMsg($event,'pvl')"></p-checkbox>
                            <label style="margin: 8px;" for="pvl">Patient View Link</label>
                        </div> -->
                    </div>


                    <div>
                        <label style="vertical-align:top; margin-right: 50px; font-weight: bold;">Message :</label>
                        <textarea id="msg" pInputTextarea class="format-lines"
                            style="border-radius:15px;margin: 10px;width: 80%;height: 20vh;" name="messagemodel"
                            #messagemodel="ngModel" placeholder="Enter your message here"
                            [(ngModel)]="newMessageToSendMsg" required></textarea>

                        <div style="text-align: center;">
                            <p [style.color]="newMessageToSendMsg.length-max_message_length-1>0?'red':'green'"
                                style="text-align: center;">
                                {{(max_message_length+1-newMessageToSendMsg.length)
                                <0?0:max_message_length-newMessageToSendMsg.length}} of {{max_message_length}}
                                characters left </p>
                        </div>
                        <div *ngIf="messagemodel.invalid && (messagemodel.dirty || messagemodel.touched)"
                            class="alert alert-danger">
                            <div style="text-align: center;" *ngIf="messagemodel.errors.required">
                                Message is required.
                            </div>
                        </div>

                    </div>


                    <div class="text-center">
                        <button pButton type="submit" style="margin:10px;" class="submitbutton" label="Send"
                            icon="fa fa-send m-l-5" [disabled]="!messageForm.valid || this.api_result.Posting"></button>
                        <button pButton type="reset" style="margin:10px;" class="submitbutton" label="Discard"
                            icon="fa fa-trash-o m-l-5" [disabled]="this.api_result.Posting"
                            (click)="closeShowDetailMsg()"></button>
                    </div>
                </div>
                <app-loading *ngIf="this.api_msg_result.Posting" type="POSTING_DATA"></app-loading>
                <app-error-messages style="text-align: center;" [api_result]="this.api_msg_result"></app-error-messages>

            </form>
        </div>
    </div>
</div>
